import Vue from "vue";
import * as Sentry from "@sentry/vue";

/**
 * @typedef {Object} sentryOptions - Sentry.init()的初始化配置
 * @description Basic Options更多配置，查阅官网：https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/
 * @property {string} dsn - 上报地址
 * @property {string} release - 版本号,默认从window.SENTRY_RELEASE.id读取。
 * @property {string} environment - 当前环境，默认从window.SENTRY_ENVIRONMENT读取。
 * @property {number} sampleRate - 错误事件采样率，范围(0.0,1.0),默认1.0。举例一，若1.0，发送100%的错误事件；举例二，若0.1，发送10%的错误事件，该10%为随机选择！
 * @property {number} maxBreadcrumbs - 捕获痕迹(Breadcrumbs面包屑)的数量，默认100。面包屑是指在应用程序中用户的活动轨迹、关键操作、状态变化等信息的记录，以便在事件发生时能够更好地理解事件的上下文和触发条件。
 * @property {boolean} attachStacktrace - 堆栈追踪，默认false。代码执行的调用链，有助于定位和理解发生错误的上下文。
 * @property {string[]} ignoreErrors - 忽略(不捕获)的错误信息,接收字符串或正则表达式。
 * @property {string[]} ignoreTransactions - 忽略(不捕获)的事务信息,接收字符串或正则表达式。
 * @property {string[]} denyUrls - 忽略特定Url出现的错误，接收字符串或正则表达式。举例一，忽略'example.com/script.js'.
 * @property {string[]} allowUrls - 接收特定Url出现的错误，接收字符串或正则表达式。
 * @property {boolean} autoSessionTracking - 事务追踪，默认true。
 * @property {Object} initialScope - 初始化的作用域。可存一些额外信息，例如用户信息、标签等，这样在所有的事件中都会包含这些信息。
 * @property {boolean} enabled -  Sentry 发送事件的开关，默认true。举例，若为false，不上报到后台，但不会阻止Sentry检测，所以依然存在Sentry的性能开销。
 *
 * @description integrations的具体配置，查阅官网：https://docs.sentry.io/platforms/javascript/guides/vue/configuration/integrations/
 * @property {array} integrations - 自定义集成功能。
 * @property {boolean} defaultIntegrations - 一些Sentry默认自带的集成，默认值true。
 *
 * @property {number} tracesSampleRate - 追踪的采样率
 * @property {string[]} tracePropagationTargets - 接收字符串或正则表达式。
 *
 * @description replays***SampleRate: 操作回放(▶)的录制比例
 * @property {number} replaysSessionSampleRate - 正常-录制比例
 * @property {number} replaysOnErrorSampleRate - 错误-录制比例
 * */

// 在不影响业务正常运行的情况下，初始化Sentry。
try {
  /**
   * @type {sentryOptions}
   */
  const sentryOptions = {
    Vue,
    // enable: 监控上报到后台的开关
    // enabled: window.$config.SENTRY_ENABLED,
    enabled: true,

    // dsn:上报地址
    dsn: window.$config.SENTRY_DSN,

    // release:版本号,默认从window.SENTRY_RELEASE.id读取。
    release: window.$config.VERSION_NUMBER || "Version not detected",

    // environment:当前环境，默认从window.SENTRY_ENVIRONMENT读取。
    environment: window.$config.VUE_APP_RUM_TYPE,

    // integrations:自定义集成功能
    integrations: [
      // 集成：BrowserTracing性能监控
      // new Sentry.BrowserTracing(),

      // 集成：replayIntegration操作回放
      Sentry.replayIntegration({
        // maskAllText,是否隐藏所有文本。如果设置为 true，则会隐藏所有文本，包括用户输入、页面上的文本和网络请求的响应。
        maskAllText: false,
        // blockAllMedia,是否阻止所有媒体。如果设置为 true，则会阻止所有媒体，包括图像、视频和音频。
        blockAllMedia: false
      })
    ],

    // tracesSampleRate:追踪的采样率
    tracesSampleRate: 1.0,

    // tracePropagationTargets:接收字符串或正则表达式。
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

    // replaysSessionSampleRate:回放，正常-录制比例
    // replaysSessionSampleRate: window.$config.REPLAYS_SESSION_SAMPLE_RATE || 0.1,
    replaysSessionSampleRate: 0.1,

    // replaysOnErrorSampleRate:回放，错误-录制比例
    // replaysOnErrorSampleRate: window.$config.REPLAYS_ON_ERROR_SAMPLE_RATE || 1.0,
    replaysOnErrorSampleRate: 1.0
  };

  Sentry.init(sentryOptions);

  // 自定义标签
  // 区分 高盈金融App 与 高盈金融多账户 项目
  // Sentry.setTag("PROJECT-NAME", window.$config.BASE_PROJECT_NAME);
} catch (err) {
  
}
